// Shared application event bus.
//
// Vue 3 removes the instance `$on` / `$off` / `$emit` methods that the Vue 2
// code used via `this.$root.$on(...)` / `this.$root.$emit(...)` for
// cross-component messaging. A single shared `mitt` emitter replaces that root
// bus. Components import this module directly and register/unregister handlers.
//
// Preserved event catalog (from the Vue 2 implementation):
//   'sendMsg'               -> { title, color, msg }
//   'onErr'                 -> error (HTTP error object)
//   'onUpdateEnv'           -> env (string)
//   'toggle-sidebar'        -> (no payload)
//   'toggle-sidebar-mobile' -> (no payload)
//
// mitt delivers a single payload per emit, so the multi-argument Vue 2 emit
// `sendMsg(title, color, msg)` is wrapped into one object payload
// `{ title, color, msg }` and unpacked by the listener, preserving behavior.

import mitt from 'mitt'

// The shared emitter instance. Exposes `emit`, `on`, and `off`.
const emitter = mitt()

/**
 * Emit a `sendMsg` event, wrapping the Vue 2 multi-argument signature
 * `sendMsg(title, color, msg)` into a single `{ title, color, msg }` payload.
 *
 * @param {string} title
 * @param {string} color
 * @param {string} msg
 */
export function sendMsg(title, color, msg) {
  emitter.emit('sendMsg', { title, color, msg })
}

export const emit = emitter.emit
export const on = emitter.on
export const off = emitter.off

export default emitter
